import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CommonService } from '../../common-service';
import { GetSafeIdDataResponse } from '../../responses/orchestrator-user/get-safe-id-data.response';

@Injectable({
  providedIn: 'root'
})
export class SafeIdHealthUnitDataService extends CommonService {

  constructor(private httpClient: HttpClient) { super(); }

  public get(): Observable<GetSafeIdDataResponse> {
    let uri = `SafeIdHealthUnitData`;

    return this.httpClient.get<GetSafeIdDataResponse>(environment.urlApiOrchestratorUser + uri, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}